import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Stack } from '@mui/material';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { motion } from 'framer-motion';

const Services = () => {
  const deepGolden = "#B8860B";
  const saffronGradient = "linear-gradient(135deg, #FF8C00 0%, #B8860B 100%)";

  const serviceList = [
    {
      title: "भक्ती स्वर-संग्रह",
      desc: "सुमधुर स्तवन, भक्ती रचना आणि प्रोफेशनल कराओके ट्रॅक्सचा खजिना. तुमच्या भक्तीला द्या संगीताची जोड.",
      icon: <MusicNoteIcon sx={{ fontSize: 35, color: '#fff' }} />, // आयकॉन साईज कमी केली
    },
    {
      title: "पूजाविधी मार्गदर्शक",
      desc: "नित्य पूजा, अभिषेक आणि विशेष जैन विधानांची शास्त्रोक्त माहिती. विधीवत भक्तीचा तुमचा डिजिटल सोबती.",
      icon: <MenuBookIcon sx={{ fontSize: 35, color: '#fff' }} />,
    }
  ];

  return (
    <Box sx={{ py: { xs: 6, md: 10 }, bgcolor: '#fafafa' }}>
      <Container maxWidth="md"> {/* दोन कार्ड्ससाठी कंटेनरची रुंदी संतुलित केली */}
        
        {/* --- SECTION HEADER --- */}
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 6 } }}>
          <Typography 
            variant="overline" 
            sx={{ color: deepGolden, fontWeight: 700, letterSpacing: 1.5, display: 'block', mb: 1, fontSize: '0.8rem' }}
          >
            आमची वैशिष्ट्ये
          </Typography>
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 800, 
              fontFamily: "'serif'", 
              fontSize: { xs: '1.8rem', md: '2.5rem' }, // फॉन्ट साईज कमी केली
              color: '#222'
            }}
          >
            आमच्या <span style={{ color: deepGolden }}>विशेष</span> सेवा
          </Typography>
          <Box sx={{ width: '50px', height: '3px', bgcolor: deepGolden, mx: 'auto', mt: 1.5, borderRadius: '2px' }} />
        </Box>

        {/* --- SERVICES GRID --- */}
        <Grid container spacing={4} justifyContent="center">
          {serviceList.map((service, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <Card 
                  sx={{ 
                    height: '100%', 
                    textAlign: 'center', 
                    borderRadius: '24px',
                    bgcolor: '#fff',
                    position: 'relative',
                    overflow: 'visible',
                    border: '1px solid #eaeaea',
                    transition: '0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    boxShadow: '0 10px 20px rgba(0,0,0,0.03)',
                    '&:hover': { 
                      transform: 'translateY(-8px)', 
                      boxShadow: `0 15px 35px rgba(184, 134, 11, 0.12)`,
                      borderColor: deepGolden,
                      '& .icon-box': {
                        transform: 'rotateY(180deg)',
                      }
                    }
                  }}
                >
                  {/* Bottom Gradient Line */}
                  <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '4px', background: saffronGradient, borderRadius: '0 0 24px 24px' }} />

                  <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                    {/* Icon Circle */}
                    <Box 
                      className="icon-box"
                      sx={{ 
                        width: '70px', 
                        height: '70px', 
                        background: saffronGradient,
                        borderRadius: '20px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        mx: 'auto',
                        mb: 3,
                        transition: 'transform 0.6s',
                        boxShadow: '0 8px 20px rgba(255, 140, 0, 0.25)'
                      }}
                    >
                      {service.icon}
                    </Box>

                    <Typography 
                      variant="h5" 
                      sx={{ fontWeight: 700, mb: 1.5, color: '#333', fontSize: { xs: '1.2rem', md: '1.4rem' } }}
                    >
                      {service.title}
                    </Typography>

                    <Typography 
                      variant="body2" 
                      sx={{ color: '#666', lineHeight: 1.7, fontSize: { xs: '0.85rem', md: '0.95rem' }, px: 1 }}
                    >
                      {service.desc}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Services;